import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=63465b73&scoped=true&"
import script from "./MyReports.vue?vue&type=script&lang=js&"
export * from "./MyReports.vue?vue&type=script&lang=js&"
import style0 from "./MyReports.vue?vue&type=style&index=0&id=63465b73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63465b73",
  null
  
)

export default component.exports